import { ReduxAsyncActionsService } from '../../../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../../../types/ReduxAsyncActions.types';
import { GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS } from '../../actions/getSANAdPartnerZeitStatus';
import { INIT_STATE } from './GoogleMarketingPlatform.constants';
import type { GoogleMarketingPlatformState } from './GoogleMarketingPlatform.types';
import { GET_GOOGLE_AUTHENTICATION_URL, GET_GOOGLE_MARKETING_ACCOUNTS } from './actions';
import type { GoogleAction } from './actions';

function handler(
  state: WrappedReducer<GoogleMarketingPlatformState>,
  action: GoogleAction
): WrappedReducer<GoogleMarketingPlatformState> {
  switch (action.type) {
    case GET_GOOGLE_MARKETING_ACCOUNTS.request:
      return {
        ...state,
        loading: true,
      };
    case GET_GOOGLE_MARKETING_ACCOUNTS.response:
      const { accounts } = action.data;
      return {
        ...state,
        googleAccounts: accounts,
        loading: false,
      };

    case GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS.response:
      const { a_google_marketing_platform } = action.data || {};
      return {
        ...state,
        adAccountStatuses: a_google_marketing_platform,
        loading: false,
      };

    case GET_GOOGLE_AUTHENTICATION_URL.response:
      const { url } = action.data;
      return {
        ...state,
        authenticationUrl: url,
      };

    default:
      return state;
  }
}

const GoogleMarketingPlatform = ReduxAsyncActionsService.wrapReducer(INIT_STATE, handler, {
  request: [GET_GOOGLE_AUTHENTICATION_URL, GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS, GET_GOOGLE_MARKETING_ACCOUNTS],
  error: [GET_GOOGLE_AUTHENTICATION_URL, GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS, GET_GOOGLE_MARKETING_ACCOUNTS],
  resetOn: ['APP_CHANGE'],
});

export default GoogleMarketingPlatform;
